import { Form, Header, Input } from 'semantic-ui-react';
import { Formik, FormikProps } from 'formik';
import './OrganisationDomainForm.less';

interface OrganisationDomainFormFields {
	organisationDomain: string;
}

interface OrganisationDomainFormProps {
	onSubmit: (values: OrganisationDomainFormFields, actions: any) => void;
	onDomainChange?: (e: React.ChangeEvent<any>) => void;
	renderActionButtons?: (isSubmitting: boolean) => React.ReactNode;
	loading?: boolean;
	unavailable?: boolean;
}

export const OrganisationDomainForm: React.FC<OrganisationDomainFormProps> = ({
	loading,
	onSubmit,
	renderActionButtons,
	unavailable,
	onDomainChange,
}) => {
	return (
		<Formik
			onSubmit={onSubmit}
			initialValues={{
				organisationDomain: '',
			}}
			validate={(values: OrganisationDomainFormFields) => {
				const errors: Partial<OrganisationDomainFormFields> = {};

				if (!values.organisationDomain) {
					errors.organisationDomain = 'Organisation ID is required.';
				}

				if (!/^[a-zA-Z0-9-]{3,}$/.test(values.organisationDomain.trim())) {
					errors.organisationDomain =
						'Organisation ID should only contain alphanumeric characters and/or a hyphen.';
				}

				return errors;
			}}
		>
			{({
				values,
				errors,
				touched,
				handleChange,
				handleBlur,
				handleSubmit,
				isSubmitting,
			}: FormikProps<OrganisationDomainFormFields>) => (
				<Form className='organisation-domain-form' onSubmit={handleSubmit}>
					<Header as='h3'>Organisation's web domain</Header>
					<p>
						Choose the address the members will use to sign in to My Spending
						Planner.
					</p>
					<div className='form-fields'>
						<Form.Field
							error={
								!!(
									touched.organisationDomain &&
									(errors.organisationDomain || unavailable)
								)
							}
						>
							<label htmlFor='orgDomain'>Organisation ID</label>
							<div className='labeled'>
								<Input
									autoFocus
									fluid
									loading={loading}
									id='orgDomain'
									type='text'
									name='organisationDomain'
									placeholder='Organisation ID'
									onChange={(e) => {
										handleChange(e);
										if (onDomainChange) {
											onDomainChange(e);
										}
									}}
									onBlur={handleBlur}
									value={values.organisationDomain}
									icon={
										touched.organisationDomain &&
										!errors.organisationDomain &&
										(!unavailable ? 'checkmark' : 'remove')
									}
									error={
										!!(
											touched.organisationDomain &&
											(errors.organisationDomain || unavailable)
										)
									}
									required
								/>
								<div className='msp-domain'>.myspendingplanner.com.au</div>
							</div>
							{unavailable && <small>Domain name is already taken</small>}
							{errors.organisationDomain && (
								<small className='error'>{errors.organisationDomain}</small>
							)}
						</Form.Field>
					</div>
					{renderActionButtons && renderActionButtons(isSubmitting)}
				</Form>
			)}
		</Formik>
	);
};
